// Filtros
(function () {
  'use strict';
  // Envia filtros
  $('#ordena').on('change', function () {
    enviaFiltros();
  });
  $('.pag-anuncios #form-fabricantes-busca').on('submit', function (e) {
    e.preventDefault();
    enviaFiltros();
  });
  $('#form-fabricantes-filtros').on('submit', function (e) {
    e.preventDefault();
    enviaFiltros();
  });
  function enviaFiltros() {
    var dados = $(
      '#form-fabricantes-busca, #form-fabricantes-filtros, #form-fabricantes-ordem',
    ).serialize();
    window.location = url_base + 'fabricantes?' + dados;
  }
})();
